import { cache, createAsync, RouteSectionProps } from "@solidjs/router";
import { Accessor, Show, Suspense } from "solid-js";
import { AnalyticsServiceProvider } from "~/context/analytics_service_context";
import { WebStoreContextProvider } from "~/context/webstore_context";
import { clientIdConfig } from "~/data/partner_config";
import {
  getStoreRouteData,
  WebStoreRouteData,
} from "~/server/data/store_route_data";
import HubbleAnalyticsService from "~/services/analytics_service/hubble_analytics_service";
import TataDigitalAnalyticsService from "~/services/analytics_service/td_analytics_service";
import { Mode } from "~/types";

const getStoreRouteData$C = cache(getStoreRouteData, "store");

export default function StoreLayout(props: RouteSectionProps) {
  const routeData: Accessor<WebStoreRouteData | undefined> =
    createAsync<WebStoreRouteData>(() => getStoreRouteData$C());

  return (
    <Show when={routeData()}>
      <AnalyticsServiceProvider
        analyticsService={_getAnalyticsService(
          routeData()?.clientId ?? "",
          routeData()?.mode ?? "hubble"
        )}
      >
        <WebStoreContextProvider routeData={routeData}>
          {props.children}
        </WebStoreContextProvider>
      </AnalyticsServiceProvider>
    </Show>
  );

  function _getAnalyticsService(clientId: string, mode: Mode) {
    if (clientId === clientIdConfig.tdClientId) {
      return TataDigitalAnalyticsService.getInstance({
        defaultProperties: {
          clientId,
          mode,
        },
      });
    }

    return new HubbleAnalyticsService({
      defaultProperties: {
        clientId,
        mode,
      },
    });
  }
}
